import Modal from 'react-bootstrap/Modal';
import { useEffect } from 'react';
import { useComun } from '../../../Hooks/useComun';
import { EnumParametro } from '../../../Utils/Enumeradores/ComunEnum';

const ModalInformacionArchivo = (props) => {
	const { onHide,show, ...rest } = props;
	const {  ParametroObtenerPorId, InfoCargaArchivo } = useComun();

	useEffect(()=>{
		if (show)
		{
			ParametroObtenerPorId(EnumParametro.InfoCargaArchivo)
		}
	},[show]);

	return (
			<Modal
					{...props}
					size="md"
					centered
					keyboard="false"
			>
					<Modal.Body className='p-4 gap-4 d-flex flex-column'>
					<div>
                        <div className='accordion-body p-0 '>
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
                                <i className="ico-info-circle" style={{ fontSize: '35px', color: '#043087' }}></i>
                            </div>
                            <div className='mt-5 text-center'>
								<p dangerouslySetInnerHTML={{ __html: InfoCargaArchivo || ''}}>
								</p>

                            </div>
                        </div>
					</div>
					</Modal.Body>
			</Modal>
	)
}

export default ModalInformacionArchivo
